import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RepairTaskDetailDto, RepairTaskService, UserDetailDto } from '@artemis-software/wr-api';
import { CurrentUserService } from '@services/current-user.service';
import TenantTypeEnum = UserDetailDto.TenantTypeEnum;

@Component({
  standalone: false,
  selector: 'wr-building-repair-task-overview-page',
  templateUrl: './building-repair-task-overview-page.component.html',
  styleUrls: ['./building-repair-task-overview-page.component.scss']
})
export class BuildingRepairTaskOverviewPageComponent implements OnInit {

  private readonly route = inject(ActivatedRoute);
  private readonly repairTaskService = inject(RepairTaskService);
  private readonly currentUserService = inject(CurrentUserService);

  buildingId?: string;
  contractorMissing = false;
  repairTasks: RepairTaskDetailDto[] = [];

  async ngOnInit(): Promise<void> {
    this.buildingId = this.route.snapshot.paramMap.get('id') ?? undefined;
    const user = await this.currentUserService.waitForUser();
    if (!this.buildingId || user?.tenantType !== TenantTypeEnum.Contractor) {
      this.contractorMissing = true;
      return;
    }
    this.loadRepairTasks();
  }

  loadRepairTasks(): void {
    if (!this.buildingId) {
      return;
    }
    this.repairTaskService.findAllTodoForCurrentContractorByBuilding(this.buildingId).subscribe((repairTasks) => {
      this.repairTasks = repairTasks;
    });
  }

}
